import React from 'react';
import Contact from '../components/Contact/Contact';

const ContactPage = () => <Contact />;
export default ContactPage;
